/* Ceela reviews. This list ships EMPTY on purpose.
   Only add reviews written by real customers. Invented or "seeded" reviews are deceptive,
   and in the US the FTC can fine a business for each fake review it displays.
   While this list is empty (and the star counts in the section settings are 0), the
   reviews section shows the launch message instead.

   When real reviews come in, either switch this section for a reviews app
   (Judge.me, Okendo, Loox) or add entries here in this format:
   {"n":"Name L.","in":"NL","c":"United States","r":5,"t":"Title","b":"Body text","v":"Verified buyer","d":"MM/DD/YYYY","ts":"YYYYMMDD"} */
window.CEELA_REVIEWS = [];
